import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string): string {
    const parts: string[] = value.split(' ');
    const dateParts: string[] = parts[0].split('/');
    return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
  }
}
